// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isHTMLElement = (el: any): el is HTMLElement => {
  return el && typeof el === 'object' && 'nodeType' in el && el.nodeType === Node.ELEMENT_NODE;
};

export const dataAttr = (condition: boolean | undefined) => {
  return (condition ? '' : undefined) as Booleanish;
};

export function stopEvent(event: React.SyntheticEvent) {
  event.preventDefault();
  event.stopPropagation();
}

export const contains = (parent: HTMLElement | null, child: HTMLElement | null) => {
  return parent ? parent === child || parent.contains(child) : false;
};

/**
 * Whether a key bubbling up to `event.currentTarget` was pressed inside a popup that is open below
 * it (a SelectV1 menu, any `aria-expanded="true"` combobox). Enter and Escape there pick an option or
 * close the menu, so a panel-level Enter-saves / Escape-cancels handler has to leave them alone.
 */
export const isKeyInOpenPopup = (event: React.KeyboardEvent<HTMLElement>): boolean => {
  const target = event.target as HTMLElement;
  const popup = target.closest?.('[aria-expanded="true"]');
  return !!popup && popup !== event.currentTarget && event.currentTarget.contains(popup);
};

/**
 * Whether a key bubbling up to a panel was pressed on one of its buttons. Enter on a button is that
 * button's click — the browser fires it as Enter's default action, after the event has bubbled — so
 * a panel-level Enter-saves handler that cancels it turns Enter on Cancel into Save.
 */
export const isKeyOnButton = (event: React.KeyboardEvent<HTMLElement>): boolean => (event.target as HTMLElement).tagName === 'BUTTON';
